/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// VeeValidate
import es from 'vee-validate/dist/locale/es'
// Importa VeeValidate y el Validator
import VeeValidate, { Validator } from 'vee-validate'
Vue.use(VeeValidate)
// Indicar uso de idioma español
Validator.localize('es', es)


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  acl,
  created () {
    const userPersistedData = localStorage.getItem('userInfo')
    const userRolesPersistedData = localStorage.getItem('userRoles')
    const tokenPersistedData = localStorage.getItem('token')
    if (userPersistedData) {
      const userData = JSON.parse(userPersistedData)
      const userRoles = JSON.parse(userRolesPersistedData)
      this.$store.commit('SET_USER_DATA', userData) // Reinsertamos data al $store.state luego del refresh (userData)
      this.$store.commit('SET_USER_ROLES', userRoles) // Reinsertamos data de userRoles al $store.state luego del refresh (userData)
    }
    if (tokenPersistedData) {
      const tokenData = JSON.parse(tokenPersistedData)
      this.$store.commit('SET_TOKEN_TO_HEADER_REQUEST', tokenData) // Reinsertamos data al $store.state luego del refresh (userToken)
    }
  },
  render: h => h(App)
}).$mount('#app')
